import React, { useState } from 'react';
import Alert from 'react-bootstrap/Alert';

/**
 * Dismissible warnings from lab-data API responses.
 * Closing any warning hides the whole set for this visit.
 *
 * @param {Object} props
 * @param {string[]} [props.warnings]
 */
const LabDataWarningsBanner = ({ warnings = [] }) => {
  const [dismissed, setDismissed] = useState(false);

  if (dismissed || !warnings?.length) {
    return null;
  }

  return (
    <div className="d-flex flex-column gap-2 mb-3">
      {warnings.map((message, index) => (
        <Alert
          key={`${index}-${message}`}
          variant="warning"
          dismissible
          onClose={() => setDismissed(true)}
        >
          {message}
        </Alert>
      ))}
    </div>
  );
};

export default LabDataWarningsBanner;
